import { render, staticRenderFns } from "./UserCollaborationProjects.vue?vue&type=template&id=b6692f64&"
import script from "./UserCollaborationProjects.vue?vue&type=script&lang=js&"
export * from "./UserCollaborationProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports